import { ACTION_CATEGORIES, type ActionCategory } from "@/hooks/use-action-items";

/**
 * BW19 PR-E — minimal filter strip. Category multi-select + show-done
 * toggle. Project / due_at range / has_blocker filters are reserved for
 * later builds.
 */

export function TaskFilters({
  categories,
  onToggleCategory,
  showDone,
  onToggleShowDone,
  showCancelled,
  onToggleShowCancelled,
}: {
  categories: Set<ActionCategory>;
  onToggleCategory: (c: ActionCategory) => void;
  showDone: boolean;
  onToggleShowDone: () => void;
  showCancelled?: boolean;
  onToggleShowCancelled?: () => void;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        alignItems: "center",
      }}
    >
      {ACTION_CATEGORIES.map((c) => {
        const active = categories.has(c);
        return (
          <button
            key={c}
            type="button"
            onClick={() => onToggleCategory(c)}
            aria-pressed={active}
            style={{
              padding: "6px 10px",
              background: active ? "var(--chip-hi, var(--chip))" : "var(--chip)",
              color: "var(--fg)",
              border: `1px solid ${active ? "var(--accent, var(--fg))" : "var(--hair)"}`,
              borderRadius: "var(--radius-card)",
              fontSize: 12,
              cursor: "pointer",
            }}
          >
            {c}
          </button>
        );
      })}
      <span style={{ flex: 1 }} />
      <label
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontSize: 12,
          color: "var(--fg-2)",
        }}
      >
        <input type="checkbox" checked={showDone} onChange={onToggleShowDone} />
        Show done
      </label>
      {onToggleShowCancelled && (
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            color: "var(--fg-2)",
          }}
        >
          <input
            type="checkbox"
            checked={showCancelled ?? false}
            onChange={onToggleShowCancelled}
          />
          Show cancelled
        </label>
      )}
    </div>
  );
}
